import { render, staticRenderFns } from "./VersionCheck.vue?vue&type=template&id=56533ea0&scoped=true&"
import script from "./VersionCheck.vue?vue&type=script&lang=js&"
export * from "./VersionCheck.vue?vue&type=script&lang=js&"
import style0 from "./VersionCheck.vue?vue&type=style&index=0&id=56533ea0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56533ea0",
  null
  
)

export default component.exports